// TODO: sửa lại file này
import { normalizeVietnamese } from '@/lib/utils'
import { Product, ProductVariant } from '@/types/product'

export const productCardHelper = {
  // Get current product variant
  getCurrentVariant: (
    product: Product,
    selectedVariant: number
  ): ProductVariant => {
    return product.variants[selectedVariant]
  },

  // Get prices for product
  getPrices: (product: Product) => {
    const { campaign_sale, flash_sale, regular_price, compare_price } = product

    let finalRegularPrice = regular_price

    if (campaign_sale?.regular_price) {
      finalRegularPrice = Number(campaign_sale.regular_price)
    }
    if (flash_sale?.regular_price) {
      finalRegularPrice = Number(flash_sale.regular_price)
    }

    const percent =
      finalRegularPrice < compare_price
        ? 100 - Math.round((finalRegularPrice / compare_price) * 100)
        : 0

    return {
      sale_percent: percent,
      regular_price: finalRegularPrice,
      compare_price,
    }
  },

  // Get review data
  getReviewData: (product: Product) => {
    if (!product.review?.avg) return null

    return {
      rating: Math.round((product.review.avg / 2) * 10) / 10,
      count: product.review.count,
    }
  },

  // TODO: check lại CoolClub data
  // getCoolClubData: (product: Product) => {
  //   const coolClubSale = product.coolclub_sale
  //   if (!coolClubSale) return null

  //   const variants = coolClubSale.variants
  //   if (!variants || Object.keys(variants).length === 0) return null

  //   // Get first variant's coolclub price
  //   const firstVariant = Object.values(variants)[0][0]
  //   return {
  //     price: firstVariant?.coolclub_price,
  //     isEnabled: firstVariant?.coolclub_price < product.regular_price,
  //   }
  // },
}

/**
 * Generate GA tracking value from product tags
 * Format: listing-tag_${normalizedTag}
 * @param tags - Array of product tags
 * @returns Formatted tracking value or undefined if no tags
 */
export function generateTagTrackingValue(
  tags: string[] | undefined
): string | undefined {
  if (!tags || tags.length === 0) return undefined

  const firstTag = tags[0]
  const normalizedTag = normalizeVietnamese(firstTag)

  return `listing-tag_${normalizedTag}`
}

/**
 * Rút gọn số lượng đã bán dạng "1.5k+" cho số lớn
 */
export function formatSoldCount(count: number): string {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}k+`
  }
  return `${count}+`
}
